import { CalendarCheck, Truck, WashingMachine, PackageCheck } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_7a187c08-1566-4a5d-94a6-902036d37fa8/artifacts/oin9oc2t_Untitled%20design%20%2814%29.png";

const steps = [
  {
    icon: CalendarCheck,
    number: '01',
    title: 'Schedule Pickup',
    desc: 'Call or fill out our form to set a time.',
  },
  {
    icon: Truck,
    number: '02',
    title: 'We Collect It',
    desc: 'Our team arrives at your door.',
  },
  {
    icon: WashingMachine,
    number: '03',
    title: 'Wash, Dry & Fold',
    desc: 'Professionally cleaned with care.',
  },
  {
    icon: PackageCheck,
    number: '04',
    title: 'Delivered Fresh',
    desc: 'Back to you, fresh and ready.',
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="py-24 md:py-32 bg-white relative overflow-hidden" data-testid="how-it-works-section">
      {/* Logo watermark */}
      <img src={LOGO_URL} alt="" className="logo-watermark absolute right-0 bottom-0 w-56 h-56 opacity-[0.03]" aria-hidden="true" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-16 reveal">
          <div className="flex items-center justify-center gap-3 mb-3">
            <div className="bg-white rounded-full p-1 shadow-md ring-1 ring-slate-100">
              <img src={LOGO_URL} alt="Poly Clean Center" className="w-8 h-8 object-contain" />
            </div>
            <span className="text-poly-green font-semibold text-sm tracking-wider uppercase">How It Works</span>
          </div>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-poly-blue-dark tracking-tight mb-4">
            Free Pickup & Delivery{' '}
            <span className="text-poly-blue">Made Simple</span>
          </h2>
        </div>

        {/* Steps */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
          {steps.map((step, i) => (
            <div
              key={i}
              className={`relative text-center group reveal reveal-delay-${i + 1}`}
              data-testid={`step-${i}`}
            >
              {/* Connector line (desktop only) */}
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-[60%] w-[80%] h-[2px] bg-gradient-to-r from-poly-blue-light/40 to-transparent" />
              )}
              
              <div className="relative inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-poly-blue mb-6 group-hover:scale-110 transition-transform duration-300">
                <step.icon className="w-7 h-7 text-white" />
                <span className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-poly-orange text-white text-xs font-bold flex items-center justify-center shadow-lg">
                  {step.number}
                </span>
              </div>
              
              <h3 className="font-heading font-bold text-lg text-poly-blue-dark mb-2">{step.title}</h3>
              <p className="text-poly-muted text-sm leading-relaxed max-w-xs mx-auto">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
